/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React, { useState } from 'react';
import { Hammer } from 'lucide-react';

interface LogoIconProps {
    className?: string;
    variant?: 'default' | 'metallic';
    iconUrl?: string; // Optional custom icon URL
}

export const LogoIcon: React.FC<LogoIconProps> = ({
    className = "w-8 h-8",
    variant = 'metallic',
    iconUrl = '/assets/logo.svg'
}) => {
    const [error, setError] = useState(false);

    // Metallic Gold Gradient Background
    // Thinner frame using border-[0.5px] and transparent white
    const metallicClass = "bg-gradient-to-br from-amber-300 via-yellow-500 to-amber-600 shadow-md border-[0.5px] border-white/30";
    const defaultClass = "bg-nobel-gold";
    
    // The coin is circular, so use rounded-full
    const shapeClass = "rounded-full";

    const containerClass = `${className} ${variant === 'metallic' ? metallicClass : defaultClass} ${shapeClass} flex items-center justify-center text-white relative overflow-hidden shadow-sm`;

    const renderFallback = () => (
        <Hammer size="60%" className="fill-white drop-shadow-sm" />
    );

    return (
        <div className={containerClass}>
            {/* Glossy overlay for metallic effect */}
            {variant === 'metallic' && (
                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/20 to-transparent opacity-50 pointer-events-none"></div>
            )}
            
            {error ? (
                renderFallback()
            ) : (
                <img 
                    src={iconUrl} 
                    alt="The Foundry Logo" 
                    className="w-full h-full object-contain p-1.5 relative z-10"
                    onError={() => setError(true)}
                />
            )}
        </div>
    );
};